import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import K_Icon from "../templates/K_Icon";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface IconOptions extends ComponentOptions {
    title?: string;
    bsc?: string;
}

export class Icon extends TemplateComponent {

    options: IconOptions;

    constructor(options: IconOptions) {
        super(K_Icon, options);
    }

    create() {
        const localizedTitle = ll(this.options.title);
        if(localizedTitle){
            toolTip({
                content: localizedTitle,
                alignX: "right",
                alignY: "center",
                alignTo: "target",
                offsetX: 5,
                selector: $("#" + this.options.id)
            });
        }
    }

}
